import React, { useState, useEffect, useRef } from 'react';
import UploadService from 'services/FileUploadService';
import LinearProgress from '@mui/material/LinearProgress';
import { Card, CardMedia, FormControl, CardContent } from '@mui/material';

import {
  Box,
  Typography,
  Button,
  ListItem,
  Grid,
  CardHeader,
  Avatar,
  IconButton,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import Loading from 'app/components/MatxLoading/MatxLoading';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CropIcon from '@mui/icons-material/Crop';
import SaveIcon from '@mui/icons-material/Save';
import DownloadIcon from '@mui/icons-material/Download';
import {
  increment,
  decrement,
  setFile1Data,
  setFileData,
} from 'actions/counter';

// import {
//   useFormikContext,
//   Formik,
//   Form,
//   Field,
//   ErrorMessage,
//   useField,
// } from 'formik';
import { unstable_useControlled } from '@mui/utils';
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { useDebounceEffect } from '../components/Cropper/useDebouceEffect';
import { canvasPreview } from '../components/Cropper/CanvasPreview';

//https://codesandbox.io/s/github/bezkoder/react-hooks-file-upload?file=/src/components/FileUpload.js
//https://www.bezkoder.com/material-ui-file-upload/   <--- class component
//https://www.bezkoder.com/react-hooks-file-upload/   <--- function component

//https://stackoverflow.com/questions/69037974/react-hook-form-materail-ui-textfield-onsubmit-not-passing-filelist-in-the-d

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 6,
    borderRadius: 5,
  },
  colorPrimary: {
    // #A3E4D7
    // #EEEEEE
    backgroundColor: '#EAFAF1',
  },
  bar: {
    // #1a90ff
    borderRadius: 5,
    backgroundColor: '#7DCEA0',
  },
}))(LinearProgress);

const UploadSignature = (props) => {
  const previewCanvasRef = React.useRef(null);
  const imgRef = React.useRef(null);
  const hiddenAnchorRef = React.useRef(null);
  const blobUrlRef = React.useRef('');
  const [crop, setCrop] = useState({
    unit: '%', // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  });
  const [completedCrop, setCompletedCrop] = useState('');
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(16 / 9);
  const onImageLoad = (e) => {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  };
  const {
    // formField: { file1Name },
    // touched,
    // errors,
    rhf,
    control,
    msg1,
    // uFile,
    formikName,
    uid,
    rdxFileData,
    rdxSetFileData,
    // formikValue,
    // formikTouch,
    // fileName,
    // selectedFiles,
    // setSelectedFiles,
    // currentFile,
    // setCurrentFile,
    // progress,
    // setProgress,
  } = props;

  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [url, setUrl] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileInfos, setFileInfos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const formikProps = useFormikContext();
  //   const { file1Name } = formikProps;
  const [isError, setIsError] = useState(false);
  const [colorFile1Name, setColorFile1Name] = useState('primary');
  const { user: currentUser } = useSelector((state) => state.auth);
  const {
    counter: { cnt, file1Data, fileData },
  } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const [signImg, setSignImg] = useState('');
  const [onCrop, setOnCrop] = useState(false);
  const [imageKey, setImageKey] = useState(Date.now());

  console.log('SignatureUpload - Component rendered with uid:', uid);

  // ดึงลายเซ็นจาก API เมื่อ uid เปลี่ยน
  useEffect(() => {
    const fetchSignature = async () => {
      // Clear state เมื่อ uid เปลี่ยน
      setSignImg('');
      
      if (uid) {
        try {
          const { data } = await axios.get(`/api/signupload/${uid}`);
          if (data?.data && data?.name) {

            // แสดงเฉพาะรูปที่อัปโหลด (ไม่ใช่ signpad)
            if (!data.name.startsWith('signpad')) {
              const buffer = Buffer.from(data.data, 'base64');
              const dataImagePrefix = `data:image/png;base64,`;
              const signImgUrl = `${dataImagePrefix}${buffer.toString('base64')}`;
              setSignImg(signImgUrl);
              setOnCrop(false); // ไม่ต้อง crop เพราะเป็นรูปที่เซ็นไปแล้ว
              console.log('SignatureUpload - Loaded uploaded signature');
            } else {
              console.log('SignatureUpload - Skipped signpad (belongs to SignaturePad tab)');
            }
          } else {
            console.log('SignatureUpload - No signature found');
          }
        } catch (error) {
          console.log('SignatureUpload - Error fetching signature:', error);
          setSignImg(''); // Clear เมื่อเกิด error
        }
      }
    };
    fetchSignature();
  }, [uid],[signImg]);

  const selectFile = async (event) => {
    const files = event.target.files;
    setSelectedFiles(files);
    setColorFile1Name('primary');
    // uploadSignature(files[0])
    if (event.target.files && event.target.files.length > 0) {
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        setSignImg(reader.result?.toString() || '')
      );
      setOnCrop(true);
      setCompletedCrop('');
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  //convert img data to base64
  useEffect(() => {
    getBase64ByDocType(fileData);
    // console.log('fileData', fileData);
  }, [fileData]);

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  const centerAspectCrop = (mediaWidth, mediaHeight, aspect) => {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  };
  const uploadSignature = (files) => {
    let currentFile = files;
    console.log('=== uploadSignature START ===');
    console.log('File:', currentFile?.name, 'Size:', currentFile?.size);
    
    if (!files) {
      console.log('---files === undefined---');
      return;
    }

    setProgress(0);
    setCurrentFile(currentFile);
    setIsLoading(true);
    
    const startTime = Date.now();
    
    const res = UploadService.removeBg(
      currentFile,
      currentUser.username,
      uid,
      formikName,
      (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      }
    )
      .then((response) => {
        console.log('=== Upload Response ===');
        console.log('response.data.data:', response?.data?.data);
        console.log('response.data.img:', response?.data?.img);
        
        // ใช้ img ถ้ามี ไม่งั้นใช้ data
        let imageData = response?.data?.img || response?.data?.data;
        
        // ถ้าเป็น Buffer object ให้แปลงเป็น base64
        if (imageData && typeof imageData === 'object' && imageData.type === 'Buffer') {
          const buffer = new Uint8Array(imageData.data);
          const base64 = btoa(String.fromCharCode.apply(null, buffer));
          imageData = `data:image/png;base64,${base64}`;
          console.log('Converted Buffer to base64');
        } else if (imageData && typeof imageData === 'string' && !imageData.startsWith('data:')) {
          imageData = `data:image/png;base64,${imageData}`;
          console.log('Added data URI prefix');
        }
        
        console.log('Final imageData length:', imageData?.length);
        
        // Update signImg และ imageKey เพื่อบังคับ re-render
        if (imageData) {
          setSignImg(imageData);
          setImageKey(Date.now());
          console.log('✅ Updated signImg and imageKey for uid:', uid);
        } else {
          console.error('❌ No image data in response!');
        }
        
        setMessage(response.data.message);
        setUrl(response.data.url);
        setFileName(response.data.name);
        setFileInfos(response.data);
        setIsLoading(false);
        onCloseCropCanvas();
        dispatch(
          setFileData({
            docType: formikName,
            name: response.data.name,
            url: response.data.url,
            data: imageData, // ใช้ imageData ที่แปลงแล้ว
            type: response.data.type,
          })
        );
        console.log('File uploaded:', response.data.name);
        setIsError(false);
      })
      .catch((error) => {
        const elapsedTime = ((Date.now() - startTime) / 1000).toFixed(1);
        console.error('❌ Upload failed after', elapsedTime, 'seconds');
        console.error('Error:', error?.message || error);
        
        // ถ้า timeout แต่ไฟล์อาจจะ upload สำเร็จแล้ว ให้ลอง fetch รูปจาก server
        if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
          console.log('⏱️ Timeout detected, trying to fetch uploaded image...');
          setTimeout(async () => {
            try {
              const { data } = await axios.get(`/api/signupload/${uid}`);
              if (data?.data || data?.img) {
                console.log('✅ Found uploaded image after timeout!');
                let imageData = data?.img || data?.data;
                
                if (imageData && typeof imageData === 'string' && !imageData.startsWith('data:')) {
                  imageData = `data:image/png;base64,${imageData}`;
                }
                
                setSignImg(imageData);
                setImageKey(Date.now());
                setMessage('Upload completed (recovered after timeout)');
              }
            } catch (fetchError) {
              console.error('Could not fetch image after timeout:', fetchError);
            }
          }, 2000);
        }
        
        setProgress(0);
        setIsLoading(false);
        setMessage('Could not upload the file! (' + (error?.message || 'Unknown error') + ')');
        setCurrentFile(undefined);
        setIsError(true);
        onCloseCropCanvas();
      });

    console.log('-----------done-----------', res);
    setSelectedFiles(undefined);
  };

  const onCloseCropCanvas = () => {
    setOnCrop(false);
    setCompletedCrop('');
    setSelectedFiles(undefined);
  };

  async function onSaveCropClick() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );
    const ctx = offscreen.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height
    );

    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: 'image/png',
    });

    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }

    const fileName =
      selectedFiles != undefined
        ? selectedFiles[0]?.name
        : getFileByDocType(fileData)?.name;
    const mimeType =
      selectedFiles != undefined
        ? selectedFiles[0]?.type
        : getFileByDocType(fileData)?.type;

    const file = new File([blob], fileName, {
      type: mimeType,
    });

    //save to db
    uploadSignature(file);
  }

  const divErrorStyle1 = {
    color: '#D32F2F',
    fontSize: '14px',
  };

  const getFileByDocType = (fileData) => {
    const tmp = fileData.find((el) => el.docType == formikName);
    return tmp;
  };

  const getBase64ByDocType = async (fileData) => {
    const tmp = fileData.find((el) => el.docType == formikName);
    const dataImagePrefix = `data:image/png;base64,`;

    // ไม่ใช้ fileData จาก Redux เพราะอาจเป็นข้อมูลของคนอื่น (idCard)
    // ใช้เฉพาะข้อมูลที่ดึงจาก API ผ่าน uid แทน
    // if (tmp?.data != undefined && !tmp?.name.includes('signpad')) {
    //   const buffer = new Buffer.from(tmp?.data, 'base64');
    //   setSignImg(`${dataImagePrefix}${buffer.toString('base64')}`);
    // }

    if (tmp?.name == '') {
      // console.log('set sign img');
      setSignImg('');
    }
  };

  const handleOnCrop = () => setOnCrop(!onCrop);

  return (
    <div className="mg20">
      {currentFile ? (
        <Box display="flex" alignItems="center">
          <Box width="100%" mr={1}>
            <BorderLinearProgress variant="determinate" value={progress} />
          </Box>
          <Box minWidth={35}>
            <Typography
              variant="body2"
              color="textSecondary"
            >{`${progress}%`}</Typography>
          </Box>
        </Box>
      ) : (
        <Typography variant="caption" component="div" color="#1e88e5">
          {msg1}
        </Typography>
      )}

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="flex-start">
          <Grid item xs={12}>
            <rhf.Controller
              type="file"
              name={formikName}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <label htmlFor={'btn-upload-' + formikName}>
                  <input
                    id={'btn-upload-' + formikName}
                    accept="image/*"
                    name={formikName}
                    style={{ display: 'none' }}
                    type="file"
                    onChange={(e) => {
                      field.onChange(selectFile(e));
                    }}
                  />

                  {/* ปุ่ม choose file */}
                  <Button
                    color={colorFile1Name}
                    variant="outlined"
                    component="span"
                  >
                    {/* Choose Files */}
                    อัพโหลดลายเซ็น
                  </Button>
                  <div style={divErrorStyle1}>
                    {error ? error.message : null}
                  </div>
                </label>
              )}
            />
          </Grid>

          {/* <Grid item xs={6} /> */}
          {isLoading && (
            <>
              {/* <div>removing..</div> */}
              <Loading />
            </>
          )}
        </Grid>
        {signImg && !isLoading && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Card sx={{ maxWidth: 2045 }}>
              <CardHeader
                style={{
                  backgroundColor: 'rgba(0,0,0,.03)',
                  borderBottom: '1px solid rgba(0,0,0,.125)',
                  padding: '0.75rem 1.25rem',
                  marginBottom: 0,
                }}
                action={
                  onCrop ? (
                    !!completedCrop && (
                      // <IconButton
                      //   aria-label="บันทึก"
                      //   onClick={onSaveCropClick}
                      // >
                      //   <SaveIcon />
                      // </IconButton>
                      <Button onClick={onSaveCropClick}> Submit </Button>
                    )
                  ) : (
                    <IconButton aria-label="crop image" onClick={handleOnCrop}>
                      <CropIcon />
                    </IconButton>
                  )
                }
                title={
                  onCrop ? (
                    <Typography variant="body2" color="red">
                      *โปรดตีกรอบครอบลายเซ็นและกด Submit เพื่อให้ลายเซ็นเข้าระบบ
                    </Typography>
                  ) : (
                    <IconButton
                      href={fileData && getFileByDocType(fileData)?.url}
                      // target="_blank"
                      aria-label="download"
                    >
                      <DownloadIcon />
                    </IconButton>
                  )
                }
                // subheader="preview"
              />

              {onCrop ? (
                <CardContent>
                  <ReactCrop
                    crop={crop}
                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                    onComplete={(c) => setCompletedCrop(c)}
                    // aspect={aspect}
                    // minWidth={400}
                    // minHeight={100}
                    // circularCrop
                  >
                    <img
                      ref={imgRef}
                      alt="Crop me"
                      src={signImg}
                      // style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                      // onLoad={onImageLoad}
                    />
                  </ReactCrop>
                  {!!completedCrop && (
                    <>
                      <div>
                        <canvas
                          ref={previewCanvasRef}
                          style={{
                            border: '1px solid black',
                            objectFit: 'contain',
                            width: completedCrop.width,
                            height: completedCrop.height,
                          }}
                        />
                      </div>
                    </>
                  )}
                </CardContent>
              ) : (
                <CardMedia
                  key={imageKey}
                  component="img"
                  // style={{ backgroundColor: "#f9f9f9" }}
                  image={signImg}
                  alt="signature"
                />
              )}
            </Card>
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default UploadSignature;
